import React from "react";
import "./index.scss";

export default function UserMessage(props) {
    return (
        <div className={props.className}>
            <div className="sender-title">
                <p className="sender">
                    <i className="far fa-comments" />
                    {props.sender === "Admin"
                        ? "پشتیبان تم ایکس"
                        : props.sender + " | " + "کاربر"}
                </p>
            </div>
            <div className="sender-body">
                <p className="body">{props.text}</p>
                <p className="time">
                    <i className="far fa-clock" />
                    {props.dateTime}
                    <span />
                    {props.attachment && (
                        <div
                            onClick={() => {
                                const url = window.URL.createObjectURL(
                                    new Blob([props.fileByteContent], {
                                        type: props.contentType
                                    })
                                );
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute("download", props.fileName);
                                document.body.appendChild(link);
                                link.click();
                                link.parentNode.removeChild(link);
                            }}
                            className="download"
                        >
                            <i className="fas fa-paperclip" />
                            <p>دانلود فایل ضمیمه</p>
                        </div>
                    )}
                </p>
            </div>
        </div>
    );
}
